import { CheckboxGroup as CheckboxGroupPrimitive } from "@base-ui/react/checkbox-group";
import * as React from "react";

import { cn } from "@beweegbaas/ui/lib/utils";
import { Field, FieldDescription, FieldLabel } from "./field";

export interface CheckboxGroupProps extends React.ComponentPropsWithoutRef<
  typeof CheckboxGroupPrimitive
> {
  label?: string;
  description?: string;
  wrapperClassName?: string;
}

function CheckboxGroup({
  label,
  description,
  wrapperClassName,
  className,
  children,
  ...props
}: CheckboxGroupProps) {
  const id = React.useId();

  const content = (
    <>
      {label && (
        <FieldLabel htmlFor={id} id={id}>
          {label}
        </FieldLabel>
      )}
      <CheckboxGroupPrimitive
        data-slot="checkbox-group"
        aria-labelledby={label ? id : undefined}
        className={cn("flex flex-col gap-2", wrapperClassName)}
        {...props}
      >
        {children}
      </CheckboxGroupPrimitive>
      {description && <FieldDescription>{description}</FieldDescription>}
    </>
  );

  if (label || description) {
    // CheckboxGroupState is structurally a FieldRootState, so the function form passes through.
    return <Field className={className}>{content}</Field>;
  }

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <CheckboxGroupPrimitive
        data-slot="checkbox-group"
        className={cn("flex flex-col gap-2", wrapperClassName)}
        {...props}
      >
        {children}
      </CheckboxGroupPrimitive>
    </div>
  );
}

// Export CheckboxGroupPrimitive for advanced use cases
export { CheckboxGroup, CheckboxGroupPrimitive };
